/** Map BE FamilyErrorMessage strings to staff-facing Studio copy. */
const FAMILY_API_ERROR_COPY: Record<string, string> = {
  'Family not found':
    'We could not find this family. Refresh the page and try again.',
  'Student not found':
    'We could not find this student. Refresh the page and try again.',
  'Parent not found in this studio':
    'That parent is not in this studio. Search again or create a new guardian.',
  'Parent is already a contact on this family':
    'That parent is already linked as a guardian on this family.',
  'Parent is already linked to another family; merging parents with students is not allowed':
    'That parent already belongs to another family. Merging households is not supported.',
  'Cannot link a parent who already has students on another household; merging is not allowed':
    'That parent already has students on another household, so they cannot be linked here.',
  'Cannot remove the billing contact; set another guardian as billing first':
    'Set another guardian as billing first, then you can remove this one.',
  'Cannot remove a guardian who is the primary parent of students on this family; turn off portal access instead':
    'This guardian is the primary parent of students on this family. Turn portal access off instead of removing them.',
  'Family contact not found':
    'That guardian is no longer on this family. Refresh and try again.',
  'Paying parent must be a FamilyContact on this family':
    'Only a linked guardian can be set as the billing contact.',
  'Studio context is required':
    'Studio context is missing. Sign out and back in, then try again.',
  'Staff access required': 'Only studio staff can manage family guardians.',
};

interface ApiErrorShape {
  response?: {
    data?: {
      message?: string | Array<string>;
      error?: string | { message?: string };
    };
  };
  message?: string;
}

const firstString = (value: unknown): string | undefined => {
  if (typeof value === 'string' && value.trim().length > 0) return value.trim();
  if (Array.isArray(value)) {
    const first = value.find(
      (item): item is string =>
        typeof item === 'string' && item.trim().length > 0,
    );
    return first?.trim();
  }
  return undefined;
};

export const extractFamilyApiMessage = (error: unknown): string | undefined => {
  const shaped = error as ApiErrorShape;
  const nestedError = shaped.response?.data?.error;
  const nestedMessage =
    typeof nestedError === 'object'
      ? nestedError.message
      : firstString(nestedError);
  return (
    firstString(shaped.response?.data?.message) ??
    firstString(nestedMessage) ??
    firstString(shaped.message)
  );
};

export const mapFamilyApiError = (error: unknown, fallback: string): string => {
  const raw = extractFamilyApiMessage(error);
  if (!raw) return fallback;
  return FAMILY_API_ERROR_COPY[raw] ?? raw;
};
